import React from "react";

import Header from "../Utils/Header/Header";
import ZeroErrorState from "../Utils/ZeroErrorState/ZeroErrorState";
import Button from "@material-ui/core/Button";

import "./404.css";

class PageMiss extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    // SEO FIX: Set a clear document title for the 404 page so Google understands
    // this is an error page and does not index it as real content.
    document.title = "Page Not Found | Midland Healthcare Lucknow";
  }

  handleHomeClick = () => {
    this.props.history.push("/");
  };

  render = () => {
    return (
      <React.Fragment>
        <Header
          history={this.props.history}
          displayRoute={this.state.displayRoute}
          activeIndex={0}
        />
        <div className="screen-container">
          <div style={{ textAlign: "center" }}>
            <ZeroErrorState />
            <div className="home-page-text">
              The page you are looking for is missing. Please click the button below to return home.
            </div>
            <Button color="primary" variant="contained" onClick={this.handleHomeClick}>
              Go to Home
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  };
}

export default PageMiss;